'use strict';

define('$navigator', function () {
  return navigator;
});
//# sourceMappingURL=navigator.js.map
